module.exports = __webpack_public_path__ + "img/xiexian2.4fdd92e5.png";